import { Image } from 'antd';
import React from 'react';

import DesignLogo from '../../../images/icons/logo_icon_redesign.svg';

interface IBrandLogoProps {
  wrapperClassName: string;
  size: number;
}

export const BrandLogo: React.FC<IBrandLogoProps> = ({
  wrapperClassName,
  size,
}) => (
  <div className={wrapperClassName}>
    <Image
      className="tw-rounded-md"
      alt="chaosarchitects_brand_logo_black"
      src={DesignLogo}
      preview={false}
      height={size}
      width={size}
    />
  </div>
);
